import React, { useEffect, useState } from "react";
// images
import hero from "./Images/hero.svg";
import aboutimage from "./Images/aboutimage.svg";
import visionbg from "./Images/visionbg.svg";
import visionicon from "./Images/visionicon.svg";
import missionicon from "./Images/missionicon.svg";
import Valuesicon from "./Images/Valuesicon.svg";
import listicon from "./Images/listicon.svg";

import DOMPurify from 'dompurify';

// icons
import { FaHome } from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";

import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import axios from "axios";


interface banner{
  title:string,
  content:string,
  id:number,
  image:string,
  pageName:String,
}


interface datastructure{
  title:string,
  content:string,
  id:number,
  image:string,
  name:String,
}

interface ContentProps {
  content: string;
}
const About = () => {

  const[bannerdata, setBannerdata] = useState<banner[]>([]);

  const[pagedata, setPagedata] = useState<datastructure[]>([]);


  const [isExpanded, setIsExpanded] = useState(false);

  // Define the maximum length before truncating the content
  const maxLength = 950; // Set a character limit to truncate
 

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<banner[]>(
          "https://rmbbackend.rmbjaipur.com/auth/aboutbanner",{
            
      });

        console.log('banner data',response.data)
        setBannerdata(response.data);
        console.log("banner data in a array",bannerdata);
      } catch (error) {
        console.error("banner Not Found:", error);
      }
    };

    fetchData();
  }, []);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<datastructure[]>(
          "https://rmbbackend.rmbjaipur.com/auth/aboutRmbContent",{
            
      });

        console.log('AboutRmbcontent data',response.data)
        setPagedata(response.data);
        console.log("aboutrmbcontent data in a array",pagedata);
      } catch (error) {
        console.error("aboutrmbcontent Not Found:", error);
      }
    };

    fetchData();
  }, []);

  const [showMore, setShowMore] = useState(false);
  return (
    <div>
      <Header />

      {bannerdata.filter((items) => items.pageName==='AboutRMB').map((items,index)=>(
        <div
        className="w-full h-[451px] relative"
        style={{
          backgroundImage: `url(https://rmbbackend.rmbjaipur.com/${items.image.replace(/\\/g, '/')})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
      >
        {/* <div className="absolute inset-0  bg-[#02256D] bg-opacity-85 "></div> */}
        <div className="relative z-10 w-[100%] h-[100%] flex flex-col  py-[20px] justify-center items-center">
          <h2 className=" text-center sm:text-[61px] text-[48px] text-[#FDBC12] font-bold ">
           {items.title}
          </h2>
          <p className="text-[20px] text-[#CBD5E0] text-center lg:w-[80%]">
            {items.content}
          </p>
          <div className="flex bg-[#1E2A3A] border border-[#465468] rounded-md py-2 px-4 mt-4 text-[#64748B]">
            <a
              className="flex gap-x-3 items-center mr-3 active:text-[#F1F4F9]"
              href="/"
            >
              {" "}
              <FaHome />
              Home
            </a>
            <a
              className="flex  gap-x-3 items-center mr-3 active:text-[#F1F4F9]"
              href="/about"
            >
              {" "}
              <IoIosArrowForward />
              About us
            </a>
            {/* <a
              className="flex gap-x-3 items-center mr-3 active:text-[#F1F4F9]"
              href=""
            >
              {" "}
              <IoIosArrowForward />
              About RMB
            </a> */}
          </div>
        </div>
      </div>
      ))}
      
      {pagedata
        .filter((items) => items.name === 'About RMB')
        .map((items, index) => {
          // Truncate content based on the maxLength
          const truncatedContent = items.content.slice(0, maxLength);

          // Sanitize content to prevent XSS (Cross-Site Scripting)
          const sanitizedContent = DOMPurify.sanitize(items.content);

          return (
            <div key={index} className="bg-[#1E2A3A] py-14 px-[8%]">
              <span className="text-[#FDBC12] text-[16px]">KNOW MORE</span>
              <h2 className="text-[#F1F4F9] text-[39px] font-bold">{items.title}</h2>
              <div className="flex flex-wrap gap-y-[20px] w-[100%]">
                <div className="lg:w-[55%] w-[100%] pr-[40px] gap-4 flex flex-col">
                  <div>
                    <p
                      className="lg:text-justify text-start flex flex-col text-[#CBD5E0] text-[20px] gap-2"
                      dangerouslySetInnerHTML={{
                        __html: isExpanded ? sanitizedContent : DOMPurify.sanitize(truncatedContent + '...'),
                      }}
                    />
                    <button
                      onClick={() => setIsExpanded(!isExpanded)}
                      className="text-[#0cbed5] mt-2"
                    >
                      {isExpanded ? 'Read Less' : 'Read More'}
                    </button>
                  </div>
                </div>

                <div className="lg:w-[45%] w-[100%]">
                  <img className="w-[100%]" src={`https://rmbbackend.rmbjaipur.com/${items.image}`} alt="" />
                </div>
              </div>
            </div>
          );
        })}
      {/* <div className="bg-[#1E2A3A] py-14 px-[8%] ">
        <span className="text-[#FDBC12] text-[16px]">KNOW MORE</span>
        <h2 className="text-[#F1F4F9] text-[39px] font-bold">About RMB</h2>
        <div className="flex flex-wrap gap-y-[20px] w-[100%]">
          <div className="lg:w-[55%] w-[100%] pr-[40px] gap-4 flex flex-col">
            <p className="lg:text-justify text-start text-[#CBD5E0] text-[20px]">
              At Rotary Means Business Jaipur, our vision is to foster a vibrant
              community of business leaders who are committed to ethical
              practices, collaboration, and service above self. We believe that
              business is not just about profit, but also about creating
              positive change in our society.
            </p>
            <p className="lg:text-justify text-start text-[#CBD5E0] text-[20px]">
              Our mission is to connect entrepreneurs, professionals, and
              business owners within the Rotary network to share knowledge,
              resources, and opportunities. We aim to cultivate a culture of
              mutual support and mentorship that empowers our members to grow
              both personally and professionally.
            </p>
            <p className="lg:text-justify text-start text-[#CBD5E0] text-[20px]">
              Through regular networking events, workshops, and collaborative
              projects, we strive to enhance the entrepreneurial spirit in
              Jaipur while upholding the values of Rotary. Our vision
              encompasses: {!showMore && (
              <button
                className="text-white text-[16px] underline cursor-pointer mt-2"
                onClick={() => setShowMore(true)}
              >
                Read More
              </button>
            )}
            </p>

            
            {showMore && (
              <>
                <ul>
                  <li className="lg:text-justify text-start text-[#CBD5E0] text-[20px]">
                    * Ethical Business Practices: Promoting integrity and
                    accountability in all business dealings.
                  </li>
                  <li className="lg:text-justify text-start text-[#CBD5E0] text-[20px]">
                    * Networking Opportunities: Creating a platform for members
                    to connect, collaborate, and create lasting partnerships.
                  </li>
                  <li className="lg:text-justify text-start text-[#CBD5E0] text-[20px]">
                    * Community Impact: Leveraging our collective resources to
                    address local challenges and contribute to sustainable
                    development.
                  </li>
                  <li className="lg:text-justify text-start text-[#CBD5E0] text-[20px]">
                    * Continuous Learning: Encouraging professional development
                    through workshops, seminars, and knowledge-sharing sessions.
                  </li>
                </ul>

                <p className="lg:text-justify text-start text-[#CBD5E0] text-[20px]">
                  Together, we envision a thriving business ecosystem in Jaipur
                  that not only drives economic growth but also uplifts our
                  community through service and goodwill. Join us in making a
                  difference—because together, we can achieve more!
                </p>
              </>
            )}
            
            {showMore && (
              <button
                className="text-white text-[16px] underline cursor-pointer mt-2"
                onClick={() => setShowMore(!showMore)}
              >
                Read Less
              </button>
            )}
          </div>

          <div className="lg:w-[45%] w-[100%]">
            <img className="w-[100%]" src={aboutimage} alt="" />
          </div>
        </div>
      </div> */}
      <div
        className="w-full  relative py-[80px] px-[8%]"
        style={{
          backgroundImage: `url(${visionbg})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
      >
        <div className="absolute inset-0  bg-[#1E2A3A] bg-opacity-90 "></div>
        {/* <div className="flex flex-wrap gap-y-5 w-[100%] relative justify-between">
          <div className="bg-[#101729] border-2 border-[#344056] p-10 flex flex-col items-center md:w-[32%] w-[100%] rounded-[16px]">
            <img className="w-[72px] h-[72px]" src={visionicon} alt="" />
            <h2 className="text-[#CBD5E0] text-[31px] font-semibold mt-5">
              Vision
            </h2>
            <p className="text-[#CBD5E0] text-[16px] text-center mt-5 mb-5">
              To create a global network of Rotarians who support each other’s
              professional growth while maintaining Rotary’s commitment to
              integrity, service, and community impact.
            </p>
          </div>
          <div className="bg-[#101729] border-2 border-[#344056] p-10 flex flex-col items-center md:w-[32%] w-[100%] rounded-[16px]">
            <img className="w-[72px] h-[72px]" src={missionicon} alt="" />
            <h2 className="text-[#CBD5E0] text-[31px] font-semibold mt-5">
              Mission
            </h2>
            <p className="text-[#CBD5E0] text-[16px] text-center mt-5 mb-5">
              Our mission is to promote ethical business practices while
              enhancing professional relationships among Rotarians and Non
              Rotarians . We aim to create a platform where members can share
              their experiences, expertise, and resources, ultimately
              contributing to the betterment of our communities and the world at
              large.
            </p>
          </div>
          <div className="bg-[#101729] border-2 border-[#344056] p-10 flex flex-col  md:w-[32%] w-[100%] rounded-[16px]">
            <div className="w-[100%] flex flex-col items-center">
              <img className="w-[72px] h-[72px]" src={Valuesicon} alt="" />
              <h2 className="text-[#CBD5E0] text-[31px] font-semibold mt-5">
                Values
              </h2>
            </div>
            <p className="flex gap-x-3 text-[#CBD5E0] text-[16px] mt-5 ">
              <img src={listicon} alt="" /> Integrity
            </p>
            <p className="flex gap-x-3 text-[#CBD5E0] text-[16px] mt-2">
              <img src={listicon} alt="" /> Collaborationy
            </p>
            <p className="flex gap-x-3 text-[#CBD5E0] text-[16px] mt-2 ">
              <img src={listicon} alt="" /> Service
            </p>
            <p className="flex gap-x-3 text-[#CBD5E0] text-[16px] mt-2 mb-5">
              <img src={listicon} alt="" /> Growth
            </p>
          </div>
        </div> */}
        <div className="flex flex-wrap gap-y-5 w-[100%] relative justify-between">
        {pagedata
  .filter((items) =>
    ['Vision', 'Mission', 'Values'].includes(items.name as string) // Corrected to string
  )
  .map((items, index) => (
    <div
      key={index}
      className="bg-[#101729] border-2 border-[#344056] p-10 flex flex-col items-center md:w-[32%] w-[100%] rounded-[16px]"
    >
      <img
        className="w-[72px] h-[72px]"
        src={`https://rmbbackend.rmbjaipur.com/${items.image}`}
        alt={items.title}
      />
      <h2 className="text-[#CBD5E0] text-[31px] font-semibold mt-5">
        {items.title}
      </h2>
      <p className="text-[#CBD5E0] text-[16px] text-center mt-5 mb-5">
        {items.content}
      </p>
    </div>
  ))}


          
          
        </div>
      </div>
      <div className="bg-[#101729] py-14 px-[8%]">
        <h2 className="text-center text-[#F1F4F9] text-[39px] font-semibold">
          History of Rotary Means Business
        </h2>
        <div className="bg-[#1E2A3A] p-10 rounded-xl mt-10">
          {pagedata.filter((items)=>items.name === 'History of Rotary Means Business').map((items)=>(
            <p className="text-[#CBD5E0] text-[20px] text-justify" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(items.content) }}>
          
          </p>
          ))}
          {/* <p className="text-[#CBD5E0] text-[20px] text-justify">
            There may have been business networking groups connected to Rotary
            prior to the formation of the first Rotary Means Business group, but
            this history will focus on the groups that eventually led to the
            formation of the Rotary Means Business Fellowship.
            <br /> <br />
            In 2004, The Rotary Club of San Francisco #2 (California USA)
            launched a business networking initiative. The intention was to
            provide a platform for club members to network with each other, and
            support each other’s businesses. The names of the original Rotary
            Means Business founders are no known. This idea caught the attention
            of the District 5150 Governors in 2004-2005 and 2005-2006, who
            encouraged other areas in the district to embrace the idea of
            Rotarians supporting each other’s businesses. By 2005, both the
            southern suburbs (known locally as the Peninsula) and the northern
            suburbs (Marin County) of San Francisco had their own RMB groups.
            Over the next few years, Rotarians in other areas of the USA heard
            about the concept, and founded their own RMB groups. Many of those
            groups, including the original San Francisco group, with no central
            organization to keep them connected, eventually fell into
            inactivity. <br /> <br />
            In 2008, Tony Benner, a Rotarian from Sydney, Australia, visited the
            San Francisco Bay Area, and discovered RMB. He brought that back to
            Sydney. Their first meeting was on April 23, 2008. As such, Sydney
            became the first international chapter of RMB, which, as of this
            writing, is still going strong. <br /> <br />
            In late 2009, Jock McNeill, a member of the Rotary Club of Santa
            Rosa (California USA), brought the idea back to his home club in
            District 5130. The idea was successful, and the Santa Rosa RMB group
            began meeting monthly. Within a few months, Mark Burchill was asked
            to chair the RMB group. A while later, another member of the group
            who was an accomplished web developer volunteered to create a
            website. Shortly after{" "}
            <a className="text[16px] hidden sm:inline" href="">
              www.RotaryMeansBusiness.org
            </a>{" "}
            <a className="text[16px]  hidden sm:none" href="">
              www.RotaryMeans <br />
              Business.org
            </a>
            was launched in 2011, Rotarians from far and wide began connecting
            with RMB. <br /> <br />
            At that point, the Chair of the Santa Rosa group realized that the
            RMB concept had the potential to be much bigger than a collection of
            random networking groups. He thought it might have the potential to
            qualify as a Rotary Fellowship. So he pulled together a steering
            committee and researched the requirements to become a Fellowship.
            The RMB Steering Committee crafted a set of governing documents, and
            worked to fulfill the other requirements to become an official
            Rotary Fellowship. <br /> br The application was submitted in summer
            2013. In November 2013, the Rotary International Board of Directors
            approved the application, and Rotary Means Business became an
            official Rotary Fellowship. Upon approval as an official Rotary
            International Fellowship, the first local chapter to join was, of
            course the “mother chapter” from District 5130. In short order,
            existing RMB groups in New York, Australia, and the San Francisco
            Bay Area joined. By the end of 2014, the RMB Fellowship had 8
            chapters and more than 150 individual members. In the time since its
            charter, the Rotary Means Business Fellowship has continued to grow,
            and to become a more integral part of the Rotary experience. In
            2017, RMB partnered with Rotary Global Rewards to enhance the value
            of both organizations. RMB has truly shown the value of business
            networking among Rotarians as a benefit that aids both membership
            recruitment and retention.
          </p> */}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default About;
